import styled from "styled-components";

export const CoreCountriesCellWrapper = styled.div`
    display: flex;
    align-items: center;

    font-size: 16px;
`;
CoreCountriesCellWrapper.displayName = "CoreCountriesCellWrapper";

export const CoreCountriesCellIcon = styled.div`
    margin-right: 4px;
`;
CoreCountriesCellIcon.displayName = "CoreCountriesCellIcon";
